import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import BootstrapVue from 'bootstrap-vue'
import VuejsDialog from 'vuejs-dialog'
import VueResource from 'vue-resource'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import './assets/adminlte/adminlte.css'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faBars, faUser, faLock, faHome, faBookOpen, faAngleLeft,
  faClipboard, faDatabase, faClipboardList, faAngleDown, faChartArea, faMapMarked, faCog,
  faWifi, faTimes, faArrowUp, faArrowDown, faDotCircle, faExpand, faCompress,
  faWalking, faMobile, faCheckCircle, faTachometerAlt } from '@fortawesome/free-solid-svg-icons'
/* import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons' */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { L } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

// this part resolve an issue where the markers would not appear
delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

// library.add(fas)
library.add(faBars, faUser, faLock, faHome, faBookOpen, faAngleLeft,
  faClipboard, faDatabase, faClipboardList, faAngleDown, faChartArea, faMapMarked, faCog,
  faWifi, faTimes, faArrowUp, faArrowDown, faDotCircle, faExpand, faCompress,
  faWalking, faMobile, faCheckCircle, faTachometerAlt)

Vue.use(VueResource)

Vue.component('fa-icon', FontAwesomeIcon)
dom.watch()

Vue.use(BootstrapVue)
Vue.use(VuejsDialog)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
